import { createFileRoute } from '@tanstack/react-router'
import PageEntrance from '~components/motion/page-entrance'
import Safety from '~containers/app/ask-a-vet/4b_safety'

export const Route = createFileRoute('/samsung/smart-things/(app)/ask-a-vet/safety/$main_concern')({
  // 한 화면에 한 질문: 몇 번째 질문인지 주소에 둬서 뒤로 가기가 이전 질문으로 간다 (DRT-7112)
  validateSearch: (search: Record<string, unknown>): { step?: number } => {
    const step = Number(search.step)
    return Number.isInteger(step) && step > 0 ? { step } : {}
  },
  component: RouteComponent,
})

function RouteComponent() {
  const { main_concern } = Route.useParams()
  const { step } = Route.useSearch()
  return (
    <PageEntrance key={step ?? 0}>
      <Safety main_concern={main_concern} step={step} />
    </PageEntrance>
  )
}
